var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.947 18.522H5M10.474 20.043C10.59 20.043 10.684 20.141 10.684 20.261C10.684 20.381 10.59 20.478 10.474 20.478C10.4174 20.4769 10.3636 20.4535 10.3242 20.4129C10.2848 20.3722 10.2632 20.3176 10.264 20.261C10.264 20.141 10.357 20.043 10.474 20.043Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.947 15.5V20.261C15.947 21.221 15.193 22 14.263 22H6.684C5.754 22 5 21.221 5 20.26V3.74C5 2.778 5.754 2 6.684 2H8.5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 13C13.3134 13 13.4451 13 13.6254 13C13.8057 13 14.0248 13 14.25 13C14.4752 13 14.6943 13 14.8746 13C15.0549 13 15.1866 13 15.25 13M14.25 1.5V1M14.25 1.75C15.4103 1.75 16.5231 2.21094 17.3436 3.03141C18.1641 3.85188 18.625 4.96468 18.625 6.125C18.625 10.2352 19.5 10.9375 19.5 10.9375H9C9 10.9375 9.875 9.81983 9.875 6.125C9.875 4.96468 10.3359 3.85188 11.1564 3.03141C11.9769 2.21094 13.0897 1.75 14.25 1.75Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.cb38f867.svg";
export { ForwardRef as ReactComponent };